import { inject, Injectable, signal } from '@angular/core';
import { IMyBidDTO } from '../../../models/IMyBidDTO';
import { CommonHttpService } from '../../common-http.service';
import { catchError, from, Observable, switchMap, tap, throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class MyBidsService {

  private httpService = inject(CommonHttpService)
  private http = inject(HttpClient)
  private oidcSecurityService = inject(OidcSecurityService);


  myBidsSignal = signal<IMyBidDTO[]>([]);
  isLoading = signal(true);

  constructor() { }

  public getMyBids(): Observable<IMyBidDTO[]> {
    const url = `${environment.apiUrl}/v3/accounts/my-account/bids`;

    return from(this.oidcSecurityService.checkAuth()).pipe(
      switchMap(authResult => {

        if (authResult.isAuthenticated) {
          let headers = new HttpHeaders();
          headers = headers.set('Authorization', `Bearer ${authResult.accessToken}`);
          return this.httpService.get<IMyBidDTO[]>(url, undefined, headers);
        } else {
          return throwError(() => new Error('User is not authenticated'));
        }
      }),
      tap(response => {
        // console.log('my bids', response);
        this.myBidsSignal.set(response);
        this.isLoading.set(false);
      }),
      catchError((error: HttpErrorResponse) => {
        const errorMsg = typeof error.error === 'string' ? error.error : 'Unknown Error';
        return throwError(() => new Error(errorMsg));
      })
    );
  }

  public patchCoverTheFee(bidId: number, coverTheFee: boolean, cardId: number): Observable<string> {
    const url = `${environment.apiUrl}/v3/accounts/my-account/bids/${bidId}`;

    const body = new HttpParams()
      .set('cardId', cardId)
      .set('coverTheFee', coverTheFee);

    return from(this.oidcSecurityService.checkAuth()).pipe(
      switchMap(authResult => {
        if (authResult.isAuthenticated) {
          const headers = new HttpHeaders()
            .set('Authorization', `Bearer ${authResult.accessToken}`)
            .set('Content-Type', 'application/x-www-form-urlencoded')
            .set('Accept', 'application/json');

          return this.httpService.patch<string>(url, body.toString(), { headers });
        } else {
          return throwError(() => new Error('unauthenticated user or expired token'));
        }
      })
    );
  }



}
